import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';   //
import JaiTechnologies from '../assets/Images/JaiLogo.jpeg';
import '../assets/styles/Header.css';

const Navbar = () => {
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const navigate = useNavigate();

    const handleContactUs = () => {
        navigate('/contactus');
        setMenuOpen(false);
    };

    const toggleDropdown = (menu) => {
        setActiveDropdown(activeDropdown === menu ? null : menu);
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
        setActiveDropdown(null);
    };

    return (
        <nav className="navbar">

            {/* Logo */}
            <div className="logo">
                <Link to="/">
                    <img src={JaiTechnologies} alt="JaiTechnologies" className="logo-img" />
                </Link>
            </div>

            {/* Nav Links */}
            <div className={`nav-links-container ${menuOpen ? 'active' : ''}`}>
                <ul className="nav-links">

                    {/* PRODUCTS DROPDOWN */}
                    <li
                        className="dropdown"
                        onMouseEnter={() => !menuOpen && toggleDropdown('products')}
                        onMouseLeave={() => !menuOpen && toggleDropdown('products')}
                        onClick={() => menuOpen && toggleDropdown('products')}
                    >
                        <span className="dropdown-title">
                            Products <i className="bi bi-caret-down-fill"></i>
                        </span>

                        {activeDropdown === 'products' && (
                            <div className="dropdown-menu">
                                <ul>

                                    {/* ✅ FIXED — Now using <Link> instead of <a> */}
                                    <li><Link to="/CogniTip">CogniTip</Link></li>
                                    <li><Link to="/CogniQuotes">CogniQuotes</Link></li>
                                    <li><Link to="/CogniStar">CogniStar</Link></li>

                                </ul>
                            </div>
                        )}
                    </li>

                    {/* SERVICES DROPDOWN */}
                    <li
                        className="dropdown"
                        onMouseEnter={() => !menuOpen && toggleDropdown('services')}
                        onMouseLeave={() => !menuOpen && toggleDropdown('services')}
                        onClick={() => menuOpen && toggleDropdown('services')}
                    >
                        <span className="dropdown-title">
                            Services <i className="bi bi-caret-down-fill"></i>
                        </span>

                        {activeDropdown === 'services' && (
                            <div className="dropdown-menu">
                                <ul>
                                    <li><Link to="/aisdlc">AI-Powered SDLC & Automation</Link></li>
                                    <li><Link to="/aiconsulting">AI Consulting & Strategy</Link></li>
                                    <li><Link to="/aipowereddataanalysis">AI-Driven Data Intelligence</Link></li>
                                    <li><Link to="/personalizationservices">Personalization & Engagement</Link></li>
                                    <li><Link to="/computervisionsolutions">Computer Vision & NLP</Link></li>
                                    <li><Link to="/aia">AI-Powered Business Optimization</Link></li>
                                </ul>
                            </div>
                        )}
                    </li>

                    {/* ABOUT US */}
                    <li>
                        <Link to="/aboutus">About Us</Link>
                    </li>

                </ul>
            </div>

            {/* Right Side */}
            <div className="nav-right">

                <button onClick={handleContactUs} className="contact-btn">
                    Contact Us
                </button>

                {/* Mobile Menu Toggle */}
                <button className="menu-toggle" onClick={toggleMenu}>
                    {menuOpen ? <FaTimes /> : <FaBars />}
                </button>

            </div>

        </nav>
    );
};

export default Navbar;
